import { render, staticRenderFns } from "./orders-returner.vue?vue&type=template&id=b665c94e"
import script from "./orders-returner.vue?vue&type=script&lang=js"
export * from "./orders-returner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports